import { Component } from "modules/Component";

export class FilterGroup extends Component<typeof FilterGroup> {
    static readonly className = "js-filter-group-component";

    private filterGroupElement: HTMLElement;
    private filterGroupTitle: string;
    private filterGroupType: string;
    private filterGroupId: string;

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);
        this.filterGroupElement = rootElement;
        this.filterGroupTitle = rootElement.dataset.filterGroupTitle || "";
        this.filterGroupType = rootElement.dataset.filterGroupType || "";
        this.filterGroupId = rootElement.dataset.filterGroupId || "";
    }
}